import { createStore } from 'satcheljs';
import type OwaLayoutStore from './schema/owaLayoutStore';

const owaLayoutStore: OwaLayoutStore = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'null' is not assignable to type 'BrowserWidthBucket'.
    // @ts-expect-error
    browserWidthBucket: null,
    areDisplayAdsEnabled: false,
};

const store = createStore<OwaLayoutStore>('OwaLayout', owaLayoutStore)();
export let getStore = () => store;
